import getDay from 'date-fns/getDay';
import isFriday from 'date-fns/isFriday';
import isMonday from 'date-fns/isMonday';
import isSaturday from 'date-fns/isSaturday';
import isSunday from 'date-fns/isSunday';
import isThursday from 'date-fns/isThursday';
import isTuesday from 'date-fns/isTuesday';
import isWednesday from 'date-fns/isWednesday';
import { News } from '../../../../types/news';
import { DAY_LABELS, GroupedNewsByDay } from './types';

export const getCurrentDayLabel = (): typeof DAY_LABELS[number] => {
  return DAY_LABELS[getDay(Date.now())];
};

export const groupNewsByDays = (news: News[]): GroupedNewsByDay[] => {
  const sundayNews: GroupedNewsByDay['news'] = [];
  const mondayNews: GroupedNewsByDay['news'] = [];
  const tuesdayNews: GroupedNewsByDay['news'] = [];
  const wednesdayNews: GroupedNewsByDay['news'] = [];
  const thursdayNews: GroupedNewsByDay['news'] = [];
  const fridayNews: GroupedNewsByDay['news'] = [];
  const saturdayNews: GroupedNewsByDay['news'] = [];

  news.forEach((newsItem) => {
    const newsCreatedDate = new Date(newsItem.created_at);
    if (isSunday(newsCreatedDate)) sundayNews.push(newsItem);
    if (isMonday(newsCreatedDate)) mondayNews.push(newsItem);
    if (isTuesday(newsCreatedDate)) tuesdayNews.push(newsItem);
    if (isWednesday(newsCreatedDate)) wednesdayNews.push(newsItem);
    if (isThursday(newsCreatedDate)) thursdayNews.push(newsItem);
    if (isFriday(newsCreatedDate)) fridayNews.push(newsItem);
    if (isSaturday(newsCreatedDate)) saturdayNews.push(newsItem);
  });

  return DAY_LABELS.map((day) => {
    let news: GroupedNewsByDay['news'];

    switch (day) {
      case 'Sun':
        news = sundayNews;
        break;
      case 'Mon':
        news = mondayNews;
        break;
      case 'Tue':
        news = tuesdayNews;
        break;
      case 'Wed':
        news = wednesdayNews;
        break;
      case 'Thu':
        news = thursdayNews;
        break;
      case 'Fri':
        news = fridayNews;
        break;
      case 'Sat':
        news = saturdayNews;
        break;
    }

    return {
      day,
      news,
    };
  });
};
